const form = `
  <div class="formio-daily-survey">
    <div class="wizard-content">
      <div class="wizard-page" ref="{{ wizardKey }}">
        {{ components }}
      </div>
      {{ wizardNav }}
    </div>
    {{ wizardHeader }} 
  </div>
`;

export default form;
